import { FC, useMemo } from 'react'
import EditoPodcast, { EditoPodcastProps } from 'src/components/Edito/Podcast'
import { PodcastTransformer } from 'src/relay/Transformers/AudioTransformer'
import { useTranslation } from 'react-i18next'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import { RichTextTransformer } from 'src/relay/Transformers/RichTextTransformer'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'

import { BlockProps } from '../props'
import { ActionIconBackground } from '../../../components/ActionButton/types'
import { PodcastProps } from '../../../components/Podcast'

import { BlockPodcastProps } from './props'

const BlockPodcast: FC<BlockProps<BlockPodcastProps>> = ({
  data,
  configuration,
  locale,
}) => {
  const { t } = useTranslation()

  const props: EditoPodcastProps = useMemo(
    () => ({
      title: data.title || '',
      ...(data.description && {
        richTextProps: RichTextTransformer(
          data.description,
          configuration,
          locale
        ),
      }),
      ...(data.cta && {
        actionButtons: [
          ButtonTransformer({
            data: data.cta,
            theme: data.theme?.data,
            iconBackground: data.theme?.data
              ? ActionIconBackground.color
              : ActionIconBackground.default,
          }),
        ].filter((button) => !!button),
      }),
      color: getThemeColor(data.theme?.data),
      podcastProps: data.podcast
        ?.map((podcast) => PodcastTransformer(podcast, t))
        .filter((podcast) => !!podcast) as PodcastProps[],
      mediaFirstOnDesktop: data?.podcastPosition !== 'right',
      mediaFirstOnMobile: data?.mobilePodcastPosition !== 'bottom',
    }),
    [configuration, data, locale, t]
  )

  return <EditoPodcast {...props} />
}

export default BlockPodcast
